import { css } from '@emotion/react';

export const textarea = css`
  textarea {
    resize: vertical;
  }
`;
